export const ACCENT = "#C9A84C";

export const HOST = {
  name: "Najiyyah Qaasim",
  company: "QandQinsurance",
  license: "AR 22055308 · TN 3004021371 · WA 1362361",
  licenseStates: "Arkansas, Tennessee & Washington",
  initials: "NQ",
  portrait:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_debt-free-webinar/artifacts/4q4o5m29_najiyyah_avatar_1.jpg",
};

export const WEBINAR = {
  date: "",
  eyebrow: "A PERSONALIZED DEBT PAYOFF STRATEGY FOR QUALIFIED CLIENTS — NATIONWIDE",
};

export const BONUSES = [
  "Free 1-on-1 Strategy Call with Najiyyah",
  "A Personalized Review of Your Debt Profile",
  "Qualification Check — See If Debt-Free Life Fits Your Situation",
  "Your Projected Payoff Path, Explained in Plain Language",
  "A Straight Answer: Is This Right for You?",
];

export const TICKER_ITEMS = [
  "90 MINUTES",
  "4 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "NATIONWIDE COVERAGE",
  "$0 COST TO ATTEND",
  "DEBT ELIMINATION SPECIALISTS",
];

export const FALSE_BELIEFS = [
  "\u201CThis must mean bigger payments or spending money I don\u2019t have.\u201D",
  "\u201CInsurance is for after you die \u2014 it can\u2019t actually help pay off debt now.\u201D",
  "\u201CI\u2019d need to make more money for this to work for me.\u201D",
];

export const AUDIENCE_CARDS = [
  { icon: "Home", title: "Homeowners Carrying a Mortgage" },
  { icon: "CreditCard", title: "Anyone Juggling Credit Cards, Student Loans, or Car Notes" },
  { icon: "TrendingUp", title: "People Already Paying Debt Down — Who Want a Smarter, Faster Strategy" },
  { icon: "CheckCircle2", title: "Financially Responsible People Ready to See If They Qualify" },
  { icon: "HelpCircle", title: "Anyone Feeling Stressed, Stuck, or Overwhelmed by Debt" },
];

export const ROADMAP = [
  { step: "01", name: "BOOK", desc: "Request your free call in under 60 seconds. No card, no cost, no pressure." },
  { step: "02", name: "QUALIFY", desc: "We review your debt, financial, and health profile together — Debt-Free Life isn't one-size-fits-all." },
  { step: "03", name: "SEE YOUR NUMBERS", desc: "See your projected payoff path in writing — how your debt payoff may be structured, in plain language." },
  { step: "04", name: "DECIDE", desc: "Move forward if it fits — or simply walk away with clarity. Zero obligation either way." },
];

export const MODULES = [
  {
    num: "01",
    title: "SEE THE REAL COST OF YOUR DEBT",
    body: "What your mortgage, credit cards, and student loans are actually costing you in lifetime interest — and why the payoff timeline is longer than you think.",
  },
  {
    num: "02",
    title: "MEET THE DEBT-FREE LIFE METHOD™",
    body: "How a dividend-paying whole life policy may redirect money you\u2019re already spending to pay debt down sooner — and keep building cash value long after the debt is gone.",
  },
  {
    num: "03",
    title: "SEE IF YOU QUALIFY",
    body: "Debt-Free Life isn\u2019t a one-size-fits-all product. We review your health and financial/debt profile to see whether the strategy fits your specific situation.",
  },
  {
    num: "04",
    title: "KNOW YOUR NEXT STEP",
    body: "If it\u2019s a fit, Najiyyah guides you through the application process step by step. If it\u2019s not, you leave with clarity — and zero obligation.",
  },
];

export const TRANSFORMS = [
  "A clearer path to your debt payoff \u2014 with your projected timeline in writing.",
  "More breathing room and less stress, using money you\u2019re already spending.",
  "A future-focused plan \u2014 the policy\u2019s cash value may keep working for you long after the debt is gone.",
];

export const TAKEAWAYS = [
  { icon: "Map", title: "Clearer View of Your Debt", desc: "A plain-English picture of what your mortgage, cards, and loans really cost over time." },
  { icon: "BadgeCheck", title: "Personalized Payoff Projection", desc: "Your own numbers, your own timeline — mapped out in writing. Results vary by situation." },
  { icon: "MessageSquare", title: "A Straight Answer on Qualification", desc: "Debt-Free Life is for qualified clients. You'll know quickly whether it fits your profile." },
  { icon: "ClipboardList", title: "Clear Next Step", desc: "A recommendation you can act on — or not. Never any pressure, never any cost." },
];

export const FAQ = [
  {
    q: "Is the call really free?",
    a: "Yes — 100% free. There is no fee, no card on file, and nothing to buy. It's a personalized, educational conversation about your debt and whether Debt-Free Life may be a fit, at $0 out of pocket.",
  },
  {
    q: "Is this an insurance application?",
    a: "No. Booking and attending the call is not an insurance application, a medical exam, or a financial commitment of any kind. If Debt-Free Life fits your situation and you choose to move forward, Najiyyah guides you through the application process separately.",
  },
  {
    q: "Will booking affect my credit?",
    a: "Not at all. There is no credit pull, no credit check, and no lender involvement. Nothing about booking or attending the call touches your credit report in any way.",
  },
  {
    q: "Do I have to qualify?",
    a: "Yes — and that\u2019s exactly why the call matters. Debt-Free Life is not a free-for-all product: qualification depends on your health and your financial/debt profile. The call is the fastest way to find out whether you qualify, with a straight answer either way.",
  },
  {
    q: "Who is this call for?",
    a: "People carrying a mortgage, credit cards, student loans, or other debt who feel stressed or stuck and want a smarter, faster payoff strategy — especially financially responsible people who are already paying debt down and want their money to do more.",
  },
  {
    q: "What will we cover?",
    a: "Four things: the real lifetime cost of your debt, how the Debt-Free Life Method™ may redirect money you\u2019re already spending, whether you qualify based on your health and debt profile, and your projected payoff path in plain language. Results vary by individual situation.",
  },
  {
    q: "What happens after I book?",
    a: "You\u2019ll get an instant confirmation email, and Najiyyah will reach out to schedule a time that works for you. Come with your rough mortgage balance and monthly debt payments — that\u2019s all you need. Nothing is automatic and nothing is required.",
  },
  {
    q: "Do I have to buy a policy?",
    a: "No. There is zero obligation to buy anything — before, during, or after the call. If you qualify and choose to move forward, Najiyyah is compensated by the insurance carrier — never by you. The review, the projection, and the call are all free to you.",
  },
];

export const COMPLIANCE =
  "This is an educational consultation. Booking or attending a call does not constitute an insurance application or financial commitment. Debt-Free Life is available only to qualified clients; qualification depends on individual health and financial/debt profile. Results are illustrative, vary by individual, and are not guaranteed; actual outcomes depend on individual policy structure, carrier terms, and consistent premium payment. Najiyyah Qaasim is a licensed insurance professional, License # AR 22055308 · TN 3004021371 · WA 1362361. Not affiliated with or endorsed by any government agency.";

export const COPYRIGHT = "© 2026 Najiyyah Qaasim · DEBT-FREE LIFE v1.0";

export const CONSENT_TEXT =
  "I agree to receive email and text communications about my strategy call and debt-elimination strategies from Najiyyah Qaasim / QandQinsurance. Message & data rates may apply. Reply STOP to opt out at any time. Consent is not a condition of any purchase.";

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export const DEBT_SITUATIONS = [
  "Mortgage only",
  "Mortgage + credit cards",
  "Mortgage + student loans",
  "Mortgage + car notes",
  "Mortgage + multiple debt types",
  "Not a homeowner yet — just researching",
];

export const BG_IMAGES = {
  homeDusk: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/463c1c5ea588539197d6d6030f638be3883e7a39353cd55d84e78e131885da5f.jpeg",
  familyHome: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/8cb5e969ccdcd119bcab2684215992e72fabe39c28e2a87ab3d147b8d8526dd9.jpeg",
  houseKey: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/4b76b7e161ae293e5fc3ed09af19d1ec0c0148e4096701caf1696c0bb84c5bbd.jpeg",
  neighborhood: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/570c592e105bfc00b9eca352d3339153a18e93c071bccf108ecb7310feccab07.jpeg",
  deskPlanning: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/00f335041924e9a4350c9213db1d8f7b0eed295e03824cabb7b296af915a8766.jpeg",
  openDoor: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/67014247874cfa6d1302ac959abc20237d8718bcc8d9481256e423ad8a7bb2fa.jpeg",
  sunriseHome: "https://static.prod-images.emergentagent.com/jobs/0d390a93-46a1-4363-9941-6c56c2b22f79/images/b6f1c3521f98d5f94424d01ff28813ad8ce407b5df83a029489685ed84ddd75a.jpeg",
};

export const TESTIMONIAL_AVATARS = [
  "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg1ODY0MTA3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg1ODY0MTA3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/38197025/pexels-photo-38197025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];
